import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ProgressBar } from 'react-bootstrap';
import { NewCrawlContext } from '@/context/Context';
import { useGenerateTokenMutation } from '@/app/common/api/socketApi';
import historyApi from '@/app/Crawl/api/historyApi';
import { useCentrifugeProgress } from './useCentrifugeProgress';

const SocketProgressBar = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const [generateToken] = useGenerateTokenMutation();
  const [token, setToken] = useState<string | null>(null);
  const { isSubmitted, jobPage, setIsSubmitted, setCanceled } =
    useContext(NewCrawlContext);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await generateToken({
          id: jobPage,
          channels: [`personal:#${jobPage}`]
        }).unwrap();
        setToken(response.data);
      } catch (error) {
        console.error('Error fetching token:', error);
      }
    };

    if (jobPage) fetchToken();
  }, [generateToken, jobPage]);

  const handleDone = () => {
    if (isSubmitted) setIsSubmitted(false);
    localStorage.setItem('alertAfterCrawlFinish', 'show');
    dispatch(
      historyApi.util.invalidateTags(
        ['CrawlHistory'] as unknown as Parameters<
          typeof historyApi.util.invalidateTags
        >[0]
      )
    );
  };

  const { progressData, connected } = useCentrifugeProgress({
    jobPage,
    token,
    isSubmitted,
    onDone: handleDone,
    onCanceled: () => setCanceled(true)
  });

  const progressBarPercent = progressData
    ? Math.floor(
        ((progressData.url_crawled ?? 0) * 99) /
          ((progressData.url_crawled ?? 0) +
            (progressData.url_remaining ?? 0))
      )
    : 0;

  return (
    <div className="d-flex justify-content-between rounded bg-body-tertiary shadow-sm p-2 gap-1 align-items-center">
      {/* if (!connected && isSubmitted) return null; */}
      {connected && progressData ? (
        <div className="w-100">
          <div className="mb-1" style={{ fontSize: '14px' }}>
            {progressData.url_crawled} نشانی از{' '}
            {(progressData.url_crawled ?? 0) +
              (progressData.url_remaining ?? 0)}{' '}
            بررسی شده ({progressData.state})
            <span className="float-end">
              {isNaN(progressBarPercent) ? 0 : progressBarPercent}%
            </span>
          </div>
          <ProgressBar
            now={progressBarPercent}
            style={{ height: 5 }}
            className="rounded-pill align-middle"
            variant="success"
          />
        </div>
      ) : isSubmitted ? (
        <span>در حال ارسال درخواست خزش ...</span>
      ) : (
        <span>در حال اتصال برای دریافت اطلاعات خزش ...</span>
      )}
    </div>
  );
};

export default SocketProgressBar;
